import { LookupStateEffects } from './lookup-state/lookup-state.effects';

export const lookupFeatureEffects = [LookupStateEffects];
